module.exports = __webpack_public_path__ + "static/media/tsai-id.4fb9ba67.jpg";